export function toTitleCase(text: string): string {
  return text
    .toLocaleLowerCase()
    .replace(/(^|\s|-|\()(\p{L})/gu, (_, sep: string, ch: string) => sep + ch.toLocaleUpperCase());
}
